import { Component } from '@angular/core';
import { PRICING_OPTIONS } from '../../splash-page/splash.config';
import { Router } from '@angular/router';
import { ScrollService } from '../../splash-service';
@Component({
  selector: 'app-pricing',
  templateUrl: './pricing.component.html',
  styleUrls: ['./pricing.component.scss']
})
export class PricingComponent {

  pricingOptions = PRICING_OPTIONS;

  constructor(
    private scrollService: ScrollService,
    private route: Router
  ) {}
  
  navigateTo(route: any[]) {
    this.route.navigate(route);
  }

  scroll(){
    this.scrollService.triggerScroll('Contact');
  }
  
}
